import { render, staticRenderFns } from "./content-area.component.vue?vue&type=template&id=6ec2a9c0&"
import script from "./content-area.component.vue?vue&type=script&lang=ts&"
export * from "./content-area.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports